import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/index';
import { Store } from '@ngrx/store';
import { inject, Injectable } from '@angular/core';
import { of } from 'rxjs';
import { AuthActions } from '../store';

@Injectable({ providedIn: 'root' })
export abstract class QueryParamsResolver implements Resolve<any> {
  private store = inject(Store);

  resolve(): Observable<boolean> {
    this.store.dispatch(AuthActions.initQueryParams());

    return of(true);
  }
}
